import { useEffect, useState } from "react";
import { getProgramasResumen } from "../services/alertasGenericasService";

export const useResumen = (competencia = "RC") => {
  const [datos, setDatos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    setLoading(true);

    getProgramasResumen(competencia).then((result) => {
      if (!isMounted) return;
      setDatos(result);
      setLoading(false);
    });

    return () => {
      isMounted = false;
    };
  }, [competencia]);

  return { datos, loading };
};